export const iconFontAwesomeSpinnersCompactDisc = (
	<i className="fa-solid fa-compact-disc"></i>
);
